'use strict';

angular.module('buyingTipsController', [])
.controller('BuyingTipsController', ['appInfo', '$scope', '$rootScope', 'Modernizr', '$window', '$location'
    ,function (appInfo, $scope, $rootScope, Modernizr, $window, $location) {
    $scope.page = 'buyingTips';
}]);